import { all } from "@redux-saga/core/effects";
import { objectStructuresEntriesSagas } from "modules/ObjectStructures/services/Entities/sagas";
import { initObjectStructures } from "modules/ObjectStructures/services/initialization/sagas";

export function* objectStructuresSaga() {
    yield all([
        initObjectStructures(),
        objectStructuresEntriesSagas()
    ]);
}